import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const Cookies = () => {
  const { t } = useTranslation();

  return (
    <div className="page-content section">
      <SEO 
        title={t('cookies.seo_title', 'Cookiebeleid')}
        description={t('cookies.seo_desc', 'Informatie over het gebruik van cookies op de website van Luscious.')}
        canonical="/cookies"
      />
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title">{t('cookies.title', 'Cookiebeleid')}</h1>
          <p style={{ color: 'var(--text-light)', marginBottom: '2rem', textAlign: 'center', fontStyle: 'italic' }}>
            {t('cookies.last_updated', 'Laatst bijgewerkt:')} 30 december 2025
          </p>
          <div className="card" style={{ padding: '2rem', lineHeight: '1.8' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-dark)' }}>1. {t('cookies.section_1_title', 'Wat zijn cookies?')}</h2>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-medium)' }}>
              {t('cookies.section_1_text', 'Cookies zijn kleine tekstbestanden die bij het bezoeken van een website naar uw computer, tablet of mobiele telefoon worden gestuurd en daar worden opgeslagen. Cookies zorgen ervoor dat de website goed functioneert en dat wij het gebruik van de website kunnen analyseren om de gebruikerservaring te verbeteren.')}
            </p>

            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-dark)' }}>2. {t('cookies.section_2_title', 'Welke cookies gebruiken wij?')}</h2>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-medium)' }}>
              {t('cookies.section_2_text', 'Luscious maakt gebruik van verschillende soorten cookies:')}
            </p>
            
            <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--text-dark)' }}>{t('cookies.func_cookies_title', 'Functionele cookies')}</h3>
            <p style={{ marginBottom: '1rem', color: 'var(--text-medium)' }}>
              {t('cookies.func_cookies_text', 'Deze cookies zijn noodzakelijk voor het technisch functioneren van de website en uw gebruiksgemak. Ze zorgen ervoor dat de website naar behoren werkt en onthouden bijvoorbeeld uw voorkeursinstellingen.')}
            </p>

            <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--text-dark)' }}>{t('cookies.analytics_cookies_title', 'Analytische cookies')}</h3>
            <p style={{ marginBottom: '1rem', color: 'var(--text-medium)' }}>
              {t('cookies.analytics_cookies_text', 'Wij gebruiken analytische cookies (zoals Google Analytics) om inzicht te krijgen in het gebruik van onze website. Hiermee kunnen wij de structuur, navigatie en inhoud van de website zo gebruiksvriendelijk mogelijk maken voor u. De statistieken en overige rapportages herleiden wij niet naar personen.')}
            </p>

            <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--text-dark)' }}>{t('cookies.marketing_cookies_title', 'Marketing cookies')}</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-medium)' }}>
              {t('cookies.marketing_cookies_text', 'Dit zijn cookies die uw surfgedrag bijhouden. Deze cookies worden gebruikt om advertenties aan te laten sluiten bij uw interesses en om te voorkomen dat u dezelfde advertenties te vaak ziet.')}
            </p>

            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-dark)' }}>3. {t('cookies.section_3_title', 'Toestemming')}</h2>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-medium)' }}>
              {t('cookies.section_3_text', 'Bij uw eerste bezoek aan onze website hebben wij u al geïnformeerd over deze cookies en toestemming gevraagd voor het plaatsen ervan. U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kunt u ook alle informatie die eerder is opgeslagen via de instellingen van uw browser verwijderen.')}
            </p>

            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-dark)' }}>4. {t('cookies.section_4_title', 'Wijzigingen in dit cookiebeleid')}</h2>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-medium)' }}>
              {t('cookies.section_4_text', 'Wij kunnen dit cookiebeleid van tijd tot tijd wijzigen. Wijzigingen zullen op onze website worden gepubliceerd. Het is daarom aan te raden om dit cookiebeleid geregeld te raadplegen, zodat u van deze wijzigingen op de hoogte bent.')}
            </p>

            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-dark)' }}>5. {t('cookies.section_5_title', 'Contact')}</h2>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-medium)' }}>
              {t('cookies.section_5_text', 'Heeft u vragen over ons cookiebeleid? Neem dan contact met ons op via Info@Luscious.be.')}
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Cookies;
